import { render, staticRenderFns } from "./UIButtonSmall.vue?vue&type=template&id=5a7272d4&scoped=true&"
import script from "./UIButtonSmall.vue?vue&type=script&lang=js&"
export * from "./UIButtonSmall.vue?vue&type=script&lang=js&"
import style0 from "./UIButtonSmall.vue?vue&type=style&index=0&id=5a7272d4&lang=scss&"
import style1 from "./UIButtonSmall.vue?vue&type=style&index=1&id=5a7272d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7272d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7272d4')) {
      api.createRecord('5a7272d4', component.options)
    } else {
      api.reload('5a7272d4', component.options)
    }
    module.hot.accept("./UIButtonSmall.vue?vue&type=template&id=5a7272d4&scoped=true&", function () {
      api.rerender('5a7272d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/UIButtonSmall.vue"
export default component.exports